import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import { showErrorAlert } from '../utils/alert';

// 1. Impor kedua file CSS yang dibutuhkan
import './LoginPage.css'; 
import './LoginAnimation.css'; 

import logo from '../assets/images/logo.png';

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/api/users/register/self', { name, email, password });
      navigate('/verify-otp', { 
        state: { 
          userId: data.userId, 
          message: data.message, 
          email: email
        } 
      });
    } catch (error) {
      showErrorAlert(error.response?.data?.message || 'Registrasi gagal.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <form className="login-form-card" onSubmit={handleRegister}>
      <div className="login-header">
        <img src={logo} alt="Logo Perusahaan" className="login-logo-img" />
        <h1 className="login-title">Registrasi</h1>
        <p className="login-subtitle">
          Daftar Akun Memerlukan OTP Email, Jadi pastikan kamu menginput Email yang Valid!
        </p>
      </div>

        {/* 2. Gunakan struktur JSX untuk floating label */}
        <div className="form-group-floating">
          <input
            type="text"
            id="name"
            className="form-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder=" " /* Penting untuk animasi */
            required
          />
          <label htmlFor="name" className="form-label">Nama</label>
        </div>

        <div className="form-group-floating">
          <input
            type="email"
            id="email"
            className="form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder=" " /* Penting untuk animasi */
            required
          />
          <label htmlFor="email" className="form-label">Email</label>
        </div>

        <div className="form-group-floating">
          <input
            type="password"
            id="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder=" " /* Penting untuk animasi */
            required
          />
          <label htmlFor="password" className="form-label">Password</label>
        </div>
        
        {/* 3. Gunakan className yang sama untuk tombol */}
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Mendaftarkan...' : 'Daftar'}
        </button>

        <p>
          Sudah punya akun? <Link to="/login">Login di sini</Link>
        </p>
      </form>
    </div>
  );
};

export default RegisterPage;